import React from 'react';
import { motion } from 'framer-motion';
import { Target, Brain, BarChart3, Lightbulb, MessageSquare } from 'lucide-react';
const tomos = [{
  title: 'TOMO 1 — Fundamentos de Venta Rápida',
  desc: 'Aprendé a ordenar tu presencia digital, entender a tu cliente ideal y crear una oferta más atractiva para vender con más claridad.',
  color: 'from-blue-600 to-blue-800',
  icon: Target,
  shadow: 'shadow-blue-500/20'
}, {
  title: 'TOMO 2 — El Cerebro de IA',
  desc: 'Accedé a 50 prompts listos para usar en ChatGPT y ahorrar tiempo al escribir anuncios, respuestas, publicaciones y textos de venta.',
  color: 'from-orange-400 to-orange-600',
  icon: Brain,
  shadow: 'shadow-orange-500/20'
}, {
  title: 'TOMO 3 — Anuncios que Facturan',
  desc: 'Conocé la estructura base para crear campañas en Meta Ads y empezar a atraer clientes con una inversión controlada.',
  color: 'from-emerald-500 to-emerald-700',
  icon: BarChart3,
  shadow: 'shadow-emerald-500/20'
}, {
  title: 'TOMO 4 — Diseño Pro con IA',
  desc: 'Usá Canva, Midjourney y CapCut para crear piezas visuales más profesionales sin ser diseñador ni contratar a terceros.',
  color: 'from-purple-500 to-purple-700',
  icon: Lightbulb,
  shadow: 'shadow-purple-500/20'
}, {
  title: 'TOMO 5 — Cierre de Ventas por WhatsApp',
  desc: 'Aplicá un sistema práctico de conversación para responder mejor, sostener el interés y aumentar tus cierres de venta.',
  color: 'from-teal-400 to-teal-600',
  icon: MessageSquare,
  shadow: 'shadow-teal-500/20'
}];
function TomoIllustration({
  color,
  icon: Icon,
  shadow
}: {
  color: string;
  icon: any;
  shadow: string;
}) {
  return <div className="relative w-20 h-24 sm:w-24 sm:h-32 shrink-0 perspective-1000 group" data-id="element-268">
      {/* 3D Book Container */}
      <div className="relative w-full h-full transition-transform duration-500 transform-gpu group-hover:rotate-y-[-15deg] preserve-3d" data-id="element-269">
        {/* Book Spine (Side) */}
        <div className={`absolute left-0 top-0 w-4 h-full bg-gradient-to-b ${color} brightness-75 rounded-l-sm origin-left transform-gpu rotate-y-[-90deg]`} data-id="element-270" />

        {/* Book Cover (Front) */}
        <div className={`absolute inset-0 bg-gradient-to-br ${color} rounded-r-lg border-l border-white/20 flex flex-col items-center justify-center p-3 shadow-2xl ${shadow}`} data-id="element-271">
          {/* Premium Gold/Silver Accents */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-272" />
          <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-black/20 to-transparent" data-id="element-273" />

          {/* Icon Container with Glow */}
          <div className="relative" data-id="element-274">
            <div className="absolute inset-0 bg-white/20 blur-xl rounded-full scale-150" data-id="element-275" />
            <div className="relative bg-white/10 p-2.5 rounded-xl backdrop-blur-md border border-white/30 shadow-lg" data-id="element-276">
              <Icon className="w-8 h-8 sm:w-10 sm:h-10 text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.3)]" data-id="element-277" />
            </div>
          </div>

          {/* Decorative Elements */}
          <div className="mt-3 flex flex-col items-center gap-1 w-full" data-id="element-278">
            <div className="w-12 h-0.5 bg-white/40 rounded-full" data-id="element-279" />
            <div className="w-8 h-0.5 bg-white/20 rounded-full" data-id="element-280" />
          </div>
        </div>

        {/* Pages (Top) */}
        <div className="absolute top-0 left-0 w-full h-4 bg-gray-100 origin-top transform-gpu rotate-x-[90deg] rounded-sm" data-id="element-281" />
      </div>

      {/* Floor Shadow */}
      <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-4/5 h-2 bg-black/40 blur-md rounded-full scale-x-125" data-id="element-282" />
    </div>;
}
export function WhatIncludes() {
  return <section className="py-10 sm:py-20 px-4 bg-green-950/30 border-t border-green-700/20" data-id="element-283">
      <div className="max-w-4xl mx-auto" data-id="element-284">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8 sm:mb-16" data-id="element-285">
          <span className="text-4xl mb-2 sm:mb-4 block" data-id="element-286">📦</span>
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4 drop-shadow-lg uppercase" data-id="element-287">
            ¿QUÉ INCLUYE EL MEGA PACK?
          </h2>
          <p className="text-xl text-yellow-300 font-bold mb-2" data-id="element-288">
            +300 módulos organizados en 5 tomos + 3 bonos
          </p>
          <p className="text-white/80 font-medium" data-id="element-289">
            Acceso inmediato · Listo para aplicar
          </p>
          <div className="w-24 h-1 bg-white/20 mx-auto mt-4 sm:mt-8" data-id="element-290"></div>
        </motion.div>

        <div className="space-y-4 sm:space-y-6" data-id="element-291">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-green-950/50 p-6 sm:p-8 rounded-2xl border border-green-700/20 flex flex-col sm:flex-row gap-8 items-start sm:items-center hover:bg-green-950/70 transition-colors" data-id="element-292">
              <TomoIllustration color={tomo.color} icon={tomo.icon} shadow={tomo.shadow} data-id="element-293" />
              <div data-id="element-294">
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-2" data-id="element-295">
                  {tomo.title}
                </h3>
                <p className="text-white/80 text-lg leading-relaxed" data-id="element-296">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
        <div className="w-full h-px bg-white/10 mt-16" data-id="element-297"></div>
      </div>
    </section>;
}